document.addEventListener('DOMContentLoaded', () => {
  const openNavBtn = document.querySelector('#openNav');
  const closeNavBtn = document.querySelector('#closeNav');
  const navContainer = document.querySelector('.nav-drawer__wrapper');

  const openCart = document.querySelector('.nav-bar__cart-open-btn');

  /* =====================
      CART DRAWER LOGIC
  ====================== */
  const checkCartDrawer = setInterval(() => {
    if (window.cartDrawer) {
      const cartDrawer = window.cartDrawer;
      const cartOverlay = window.cartOverlay;

      if (openCart) {
        openCart.addEventListener('click', () => {
          openCartDrawer();
        });
      }

      function openCartDrawer() {
        cartDrawer.classList.add('cart-drawer--active');
        cartOverlay.classList.add('is-visible');
        cartDrawer.classList.remove('close');
        document.body.style.overflow = 'hidden';
      }

      window.openCartDrawer = openCartDrawer;
      clearInterval(checkCartDrawer);
    } else {
      // console.log('Waiting for cart drawer...');
    }
  }, 100);

  /* =====================
      NAV DRAWER OPEN/CLOSE
  ====================== */
  if (openNavBtn) {
    openNavBtn.addEventListener('click', () => {
      if (!navContainer) return;
      navContainer.classList.add('open');
      document.body.classList.add('no-scroll');
      document.body.style.overflow = 'hidden';

      const utilityBar = document.querySelector('.utility-bar');
      if (utilityBar) utilityBar.style.display = 'none';
    });
  }

  if (closeNavBtn) {
    closeNavBtn.addEventListener('click', () => {
      if (!navContainer) return;
      navContainer.classList.remove('open');
      document.body.classList.remove('no-scroll');
      document.body.style.overflow = '';

      const utilityBar = document.querySelector('.utility-bar');
      if (utilityBar) utilityBar.style.display = 'block';
    });
  }

  /* =====================
      SUBMENU TOGGLE (+ / –)
  ====================== */
  document.querySelectorAll('.nav-drawer__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('aria-controls');
      const target = document.getElementById(id);
      const open = btn.getAttribute('aria-expanded') === 'true';

      btn.setAttribute('aria-expanded', String(!open));

      if (open) {
        if (target) target.setAttribute('hidden', '');
        btn.textContent = '+';
      } else {
        if (target) target.removeAttribute('hidden');
        btn.textContent = '–';
      }
    });
  });

  /* =====================
      SMALL GREY × (mini close)
      Closes the drawer without navigating
  ====================== */
  document.addEventListener('click', (e) => {
    const isMiniClose = e.target.classList && e.target.classList.contains('nav-drawer__mini-close');
    if (!isMiniClose) return;

    if (navContainer) navContainer.classList.remove('open');
    document.body.classList.remove('no-scroll');
    document.body.style.overflow = '';

    const utilityBar = document.querySelector('.utility-bar');
    if (utilityBar) utilityBar.style.display = 'block';
  });
});